import BookingForm from '../RoofersLanding/BookingForm'

export default function BookingSection() {
    return (
        <section className="bg-[#3F454F] relative overflow-hidden">
            <div
                className="absolute w-96 h-96 rounded-full blur-3xl"
                style={{
                    top: '-6rem',
                    right: '-6rem',
                    background: 'rgba(237,92,47,0.2)',
                }}
            />
            <div
                className="absolute w-96 h-96 rounded-full blur-3xl"
                style={{
                    bottom: '-8rem',
                    left: '-6rem',
                    background: 'rgba(253,181,21,0.15)',
                }}
            />

            <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 py-10 lg:py-12 flex flex-col items-center text-center gap-0">
                <div className="w-full flex flex-col items-center gap-0 mt-0">
                    <div
                        style={{
                            width: '100%',
                            maxWidth: '1040px',
                            margin: '0 auto',
                            fontFamily:
                                "'Inter', system-ui, -apple-system, sans-serif",
                        }}>
                        <div
                            style={{
                                textAlign: 'center',
                                marginBottom: '28px',
                                padding: '0 16px',
                            }}>
                            <div
                                style={{
                                    color: '#fab331',
                                    fontSize: '0.78rem',
                                    fontWeight: 800,
                                    letterSpacing: '0.16em',
                                    textTransform: 'uppercase',
                                    marginBottom: '14px',
                                }}>
                                Get started
                            </div>
                            <h2
                                style={{
                                    color: '#ffffff',
                                    fontSize: 'clamp(1.6rem, 3.4vw, 2.5rem)',
                                    fontWeight: 800,
                                    lineHeight: 1.1,
                                    letterSpacing: '-0.02em',
                                    margin: '0 0 14px',
                                }}>
                                <span>Plan your next </span>
                                <span
                                    style={{
                                        backgroundImage:
                                            'linear-gradient(to right, #ED5C2F 10%, #F28230 35%, #FAB331 65%)',
                                        WebkitBackgroundClip: 'text',
                                        backgroundClip: 'text',
                                        color: 'transparent',
                                    }}>
                                    landscaping mail campaign.
                                </span>
                            </h2>
                            <p
                                style={{
                                    color: '#c9ccd3',
                                    fontSize: '1rem',
                                    lineHeight: 1.5,
                                    maxWidth: '620px',
                                    margin: '0 auto',
                                }}>
                                Book a strategy call and we&apos;ll review your
                                market, current marketing, service area, and job
                                goals, then recommend the best path forward.
                            </p>
                        </div>

                        <BookingForm
                            variant="dark"
                            containerId="landscaping-landing-page"
                            classPrefix="landscaping"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
